<section class="sh-dialog__content">
    <sh-loading *ngIf="(imageLoading$ | async) && !(imageError$ | async)" [message]="'ui.loading' | translate"></sh-loading>

    <ng-container *ngIf="imageError$ | async; else noError">
        <sh-notification
            [type]="notificationType.Error"
            [message]="'components.image-edit-dialog.loading-error' | translate"
            [icon]="'delete'"
        ></sh-notification>
    </ng-container>

    <ng-template #noError>
        <div class="med-cropper">
            <div class="image-cropper">
                <image-cropper
                    [maintainAspectRatio]="preserveAspectRatio$ | async"
                    [aspectRatio]="ORIGINAL_WIDTH / ORIGINAL_HEIGHT"
                    [containWithinAspectRatio]="true"
                    [imageURL]="PREVIEW_URL"
                    [transform]="imageTransform$ | async"
                    (imageCropped)="imageCropped($event)"
                    (imageLoaded)="imageLoaded($event)"
                    (loadImageFailed)="loadImageFailed()"
                ></image-cropper>
            </div>
            <ng-container *ngIf="!(imageLoading$ | async)">
                <div class="image-details">
                    <span>{{ "components.image-edit-dialog.dimensions" | translate }}</span>
                    <dl class="sh-description-list">
                        <dt class="sh-description-list__term">{{ "general.width" | translate }}</dt>
                        <dd class="sh-description-list__details">{{ computedWidth$ | async }}px</dd>
                        <dt class="sh-description-list__term">{{ "general.height" | translate }}</dt>
                        <dd class="sh-description-list__details">{{ computedHeight$ | async }}px</dd>
                    </dl>

                    <div class="sh-form-check">
                        <input
                            id="preserve-aspect-ratio"
                            class="sh-checkbox sh-form-check__input sh-form-group__input"
                            type="checkbox"
                            [checked]="preserveAspectRatio$ | async"
                            (change)="checkBox()"
                        />
                        <label for="preserve-aspect-ratio" class="sh-form-check__label">{{
                            "components.image-edit-dialog.preserve-aspect-ratio" | translate
                        }}</label>
                    </div>
                    <br />
                </div>
            </ng-container>
        </div>
    </ng-template>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" [id]="'crop'" (click)="submit()" [disabled]="false">{{ config.data.ok }}</button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{ config.data.cancel }}</button>
    </div>
</footer>
